;(function () {
  'use strict';

  /**
   * Google Authenticatorストア モーダル
   */
  var googleAuthQrModal = {
    /**
     * 初期化
     */
    init: function (type) {
      var config = $.extend({
        dialog: '.ui-dialog--google-auth-qr-' + type,          // ダイアログのセレクタ
        sideMargin: 15,                                        // 左右の余白 [px]
        openButton: '.js-dialog--google-auth-qr-' + type + '__open' // ダイアログの表示ボタン
      }, type);

      if ($('body.sp-viewport').length) {
        // sp版モーダル設定
        $(config.dialog).dialog({
          autoOpen: false,
          draggable: false,
          resizable: false,
          modal: true,
          width: $(window).width() - (config.sideMargin * 2),
          position: {
            at: 'center',
          },
          dialogClass: 'dialog-google-auth-qr',
          show: 'fade',
          hide: 'fast'
        });
      } else {
        // pc版モーダル設定
        $(config.dialog).dialog({
          autoOpen: false,
          draggable: false,
          resizable: false,
          modal: true,
          buttons: [
            {
              text: '閉じる',
              class: 'ui-dialog__button otp__dialog-close',
              click: function () {
                return $(this).dialog('close');
              },
            },
          ],
          width: 536,
          position: {
            my: 'center',
            at: 'center',
            of: window
          },
          dialogClass: 'dialog-google-auth-qr',
          show: 'fade',
          hide: 'fast'
        });
      }

      /**
       * ログインモーダル 表示イベント
       */
      $(config.openButton).on('click', function () {
        $(config.dialog).dialog('open');
        return false;
      });

      /**
       * ログインモーダル 非表示イベント
       */
      $(config.closeButton).on('click', function () {
        $(config.dialog).dialog('close');
        return false;
      });

      //ダイアログ以外の場所をタップしたらダイアログが消える
      $(document).on('click', '.ui-widget-overlay', function () {
        $(config.dialog).dialog('close');
      });
    }
  };

  /**
   * DOM content loaded
   */
  $(function () {
    googleAuthQrModal.init('ios');
    googleAuthQrModal.init('android');
  });
}.call(this));
